// @purpose GLUE
// Expose htmx globally before extensions (htmx-ext-sse) evaluate; ES imports run in order.
import htmx from "htmx.org";

window.htmx = htmx;
export default htmx;
